var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tiktok_svg__clip0_7824_5073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.913 10.162v2.473a2.155 2.155 0 00-2.7 1.995 1.945 1.945 0 002.08 2.065 1.938 1.938 0 002.08-2.094V4.8h2.447c.416 2.589 1.71 3.19 3.444 3.467v2.48a7.374 7.374 0 01-3.375-1.14v4.9c0 2.22-1.314 4.693-4.576 4.693a4.598 4.598 0 01-4.577-4.716 4.51 4.51 0 015.177-4.322z",
    fill: "#0D0C1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tiktok_svg__clip0_7824_5073"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgTiktok;